module.exports = __webpack_public_path__ + "static/media/service_font.529f9ddc.mp4";